'use client';

import mixpanel from 'mixpanel-browser';
import config from '@/config';
import SiteHeader from '@/src/components/SiteHeader';

const navLinks = [
  { href: '#use-cases', label: 'Use cases' },
  { href: '#why', label: 'Why QuizWhizzer' },
  { href: '/', label: 'For teachers' },
];

export default function BusinessHeader() {
  return (
    <SiteHeader
      homeHref="/business"
      subLabel="for Business"
      navLinks={navLinks}
      secondaryAction={{
        href: `${config.appUrl}/register?corporate=true`,
        label: 'Try it free',
        onClick: () =>
          mixpanel.track('business_try_free_clicked', { location: 'header' }),
      }}
      primaryAction={{
        href: config.bookingUrl,
        label: 'Book a demo',
        target: '_blank',
        onClick: () =>
          mixpanel.track('business_book_demo_clicked', { location: 'header' }),
      }}
    />
  );
}
